import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";

import { BlockCardComponent } from "./block/card.component";
import { SmallCardComponent } from "./small/small-card.component";
import { TableDetailRowCardComponent } from "./table-detail-row-card/table-detail-row-card.component";
import { UICardComponent } from "./ui-card/ui-card.component";
import { ButtonModule } from "../button/button.module";
import { ContainerModule } from "../container/container.module";
import { IconModule } from "../icon/icon.module";
import { InputModule } from "../input/input.module";
import { LoadingIndicatorModule } from "../loading-indicator/loading-indicator.module";
import { TextModule } from "../text/text.module";

const exportedComponents = [SmallCardComponent, BlockCardComponent, UICardComponent, TableDetailRowCardComponent];

@NgModule({
	imports: [
		CommonModule,
		LoadingIndicatorModule,
		TranslateModule,
		ContainerModule,
		ButtonModule,
		TextModule,
		IconModule,
		ReactiveFormsModule,
		InputModule,
	],
	declarations: [...exportedComponents],
	exports: [...exportedComponents],
})
export class CardModule {}
